import httpApiApplication from '../../../../http/httpApiApplication';
import { type OperationTaxRequest } from '../models/types';

export const baseUrl = '/taxvector';

export const saveTaxOperation = (
  request: OperationTaxRequest
): Promise<{ taxVectorId: string }> => {
  return httpApiApplication.post(baseUrl, request);
};

export const deleteTaxOperation = (
  request: OperationTaxRequest
): Promise<{ taxVectorId: string }> => {
  return httpApiApplication.delete(
    `${baseUrl}/tax/${request.taxId}/operation/${request.operationId}`
  );
};
